<!--票据红冲-应收款列表-->
<template>
  <div>
      <div style="height: 75vh;overflow-y: auto;" v-show="tadd == 1">
        <!-- <el-button @click="modals">生成临时费用</el-button> -->
        <el-button @click="add_list">新增临时收费</el-button>
        <el-button @click="del(1)">删除</el-button>
        <el-button @click="del(2)">全部删除</el-button>
        <el-button @click="searchs">搜索</el-button>
        <!-- <el-button @click="download">导出</el-button> -->
        <!-- 查询条件 -->
        <div style="width: 99%; margin-top: 10px">
          <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
            <el-descriptions-item label="房产">
              <el-select v-model="house" size="mini" filterable remote clearable reserve-keyword placeholder="可搜索房产/客户姓名" :remote-method="remoteMethod" :loading="loading" style="width: 100%">
                <el-option
                  v-for="item in selectList"
                  :key="item.id"
                  :label="item.house"
                  :value="item.house"
                ></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="查询模式">
              <RadioGroup v-model="searchMode">
                <Radio label=1>模糊查询</Radio>
                <Radio label=2>精确查询</Radio>
              </RadioGroup>
            </el-descriptions-item>
            <el-descriptions-item label="业户">
              <el-input v-model="user" size="mini"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="收费项目">
              <el-select v-model="chargeitemID" size="mini" multiple filterable collapse-tags style="width: 100%" placeholder="收费项目">
                <el-option  v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="计费周期">
              <el-date-picker v-model="startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="">
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="width: 99%; margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val ? money_val : 0}}</span>元</span>
          <span style="margin-left: 15px;">总金额：<span style="color: red;">{{money ? money : 0}}</span>元</span>
          <span style="margin-left: 15px;color: red;" v-if="loading">加载中...</span>
          <div>
            <el-table ref="multipleTable" height="55vh" :data="data" border style="width: 99%; margin-top: 10px" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" > </el-table-column>
<!--              <el-table-column prop="id" label="ID" width="50"></el-table-column>-->
              <el-table-column prop="customer_name" label="业户" width="100"></el-table-column>
              <el-table-column prop="address" label="房产"></el-table-column>
              <el-table-column prop="charge_name" label="临时费用名称"></el-table-column>
              <el-table-column prop="charge" label="金额" width="100"></el-table-column>
              <el-table-column prop="payment_number" label="缴款方式" width="100"></el-table-column>
              <el-table-column label="计费周期">
                <template slot-scope="scope">
                  {{scope.row.startDate}} - {{scope.row.endDate}}
                </template>
              </el-table-column>
              <el-table-column prop="bill_number" label="票据号" width="110"></el-table-column>
              <el-table-column prop="remarks" label="备注"></el-table-column>
              <el-table-column prop="date" label="操作时间" width="140"></el-table-column>
            </el-table>
          </div>
          <div class="pages" v-if="data">
            <Page
              :total="count"
              :page-size="pageSize"
              @on-change="change"
              show-total
            />
          </div>
          <div class="zhanwu" v-else>没有数据</div>
        </div>
      </div>
      <billRedFlushTemporaryAdd ref="billRedFlushTemporaryAdd" @top="top" v-show="tadd == 2"></billRedFlushTemporaryAdd>
  </div>
</template>

<script>
  import ViewFlow from "../../Common/ViewFlow.vue";

  export default {
    // 接受父组件的值
    props: {

    },
    watch:{

    },
    components: {
      "billRedFlushTemporaryAdd": () => import('./billRedFlushTemporaryAdd.vue')
    },
    data () {
      return {
        user:'',
        money: 0,
        money_val: 0,
        chargeitemID:'',
        chargeitem:[],
        tadd:1,
        maskclosable:false,
        modal1:false,
        house_1:'',
        house_name: "",
        project_id: "",
        selectList: [],
        modal: false,
        modal4: false,
        statesModal: false,
        loading: false,
        loadingModal: true,
        unlinkpanels: true,
        options: [],
        payment: [],
        charge: [],
        house: [],
        count: 0,
        pageSize: 12,
        data: [],
        order:[],
        pid: "",
        text: "",
        state: "1",
        url: "",
        fileList: [],
        form: {
          pindex_id: "",
          charge: "",
          text: "",
          charge_id: "",
          house_id: "",
          dates: "",
          payment_number: "",
          remarks: "",
          cname:"",
          user:[],
        },
        statesForm: {
          id: "",
          stutes: "",
          remarks: "",
        },
        capitalize: "",
        deposit_date: "",
        deposit: [],
        login: "",
        billNo: "",
        searchMode: "1",
        startDate : '',
        endDate : '',
        operatorStartDate : '',
        operatorEndDate : '',
      };
    },
    mounted(){
      var login = window.localStorage.getItem("login");
      var token = window.localStorage.getItem("token");
      this.url =
          this.$myhttp.defaults.baseURL +
          "/admin/excel?" +
          "login_name=" +
          login +
          "&token=" +
          token;
      //项目列表
      this.$myhttp.get("admin/common/pindex", {
        "Content-Type": "application/json",
      }).then((backdata) => {
        this.options = backdata.data.data;
      });

      //加载收款方式
      this.$myhttp
          .get("admin/common/payment", {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.payment = backdata.data.data;
          });

      //加载收费大类（费项）
      this.$myhttp
        .get("admin/common/getChargeitem", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          this.chargeitem = backdata.data.data;
        });
    },
    //事件
    methods: {
      //新增
      add_list(){
        if(this.pid == ""){
          this.$Message.error("点击左边树选择项目!");
          return false;
        }
        this.tadd = 2;
        window.localStorage.setItem("house", this.text);
        window.localStorage.setItem("project_id", this.project_id);
        this.$refs.billRedFlushTemporaryAdd.getInvo(this.house,this.pid);
      },
      top(){
        this.tadd = 1;
      },
      getInvo(house,pid){
        /*let house = this.$route.query.house;
        let user_id = this.$route.query.user_id;
        let pid = this.$route.query.pid;
        let pid_house = this.$route.query.pid_house;
        if(house){
          window.localStorage.setItem("house", house);
          window.localStorage.setItem("project_id", pid);
          this.tadd = 2;
        }*/

        console.log('house',house);
        console.log('pid',pid);
        this.pid = pid;
        this.house = house;
        this.money = 0;
        this.money_val = 0;
        this.change(1);
        if(this.tadd == 2){
          this.$refs.billRedFlushTemporaryAdd.pids(this.pid,this.house);
        }
      },
      remoteMethod(query) {
        if (query !== "") {
          // console.log(query);
          this.loading = true;
          this.$myhttp
              .get(
                  "admin/common/house_text?text=" +
                  encodeURIComponent(query) +
                  "&project_id=" +
                  this.pid,
                  {
                    "Content-Type": "application/json",
                  }
              )
              .then((backdata) => {
                // 异步执行成功后
                this.selectList = backdata.data.data;
                this.loading = false;
              });
        } else {
          this.selectList = [];
        }
      },
      //搜索房产

      //分页
      change(page=1) {
        this.loading = true;
        this.loading = false;
        let chargeitemID = '';
        if(this.chargeitemID.length >=1){
          chargeitemID = this.chargeitemID.map(req=>{return req;}).join(',');
        }
        console.log('change_pid',this.pid)
        let data = {
          'page':page,
          // 'state':this.state,
          'text':this.house,
          'pid':this.pid,
          'searchMode':this.searchMode,
          'chargeitemID':chargeitemID,
          'user':this.user,
          'startDate' :this.startDate,
          'endDate' :this.endDate,
        }
        this.$myhttp.post("admin/OrderBillRedFlushFlow/temp_index", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        }).then((backdata) => {
          if(backdata.code == 500){
            this.$Message.error(backdata.data.message);
          }else{
            let data = backdata.data;
            this.data = data.data;
            this.count = data.count;
            this.pageSize = data.pageSize;
            this.money = data.money;
          }
          this.loading = false;
        });

      },
      //搜索
      searchs() {
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        this.money = "--";
        this.change(1);
      },
      handleSelectionChange(val){
        this.order = val;
        let money = 0;
        this.order.map(req=>{
          money = Number(money) + Number(req.charge);
        })
        this.money_val = money.toFixed(2);
      },
      //删除
      del(e){
        if(this.pid == ''){
          //this.$Message.error('点击左边树选择项目');
          this.$confirm('点击左边树选择项目', '提示', {
            confirmButtonText: '关闭',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { })
          return false;
        }
        this.$confirm('确定操作吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          let chargeitemID = '';
          if(this.chargeitemID.length >=1){
            chargeitemID = this.chargeitemID.map(req=>{return req;}).join(',');
          }
          let data = {
            // 'page':page,
            // 'state':this.state,
            'text': this.house,
            'pid': this.pid,
            'searchMode': this.searchMode,
            'chargeitemID': chargeitemID,
            'user': this.user,
            'startDate': this.startDate,
            'endDate': this.endDate,

            'house': this.house,
            'type': e,
            'order': this.order
          }
          // let data = {'data':search_data,'house':this.house,'pid':this.pid,'type':e,'order':this.order}
          this.$myhttp.post('admin/OrderBillRedFlushFlow/temp_del',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            // this.change(this.page);
            this.change(1);
            //调用父组件方法
            // this.$parent.selects(1);

            if(backdata.data.code == 201){
              // this.$Message.error(backdata.data.message);
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '关闭',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => { })
              // return false;
            }
            if(backdata.data.code == 200){
              this.$Message.success('操作成功!');
            }

          },err=>{
            ERP.hideLoading()
            this.$Message.error('请求异常!');
          });
        })
      },
      del1(id) {
        this.$confirm("删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(() => {
              this.loading = true;
              this.$myhttp
                  .post(
                      "admin/OrderBillRedFlushFlow/temp_del",
                      { id: id },
                      {
                        "Content-Type": "application/x-www-form-urlencoded",
                      }
                  )
                  .then((backdata) => {
                    // 异步执行成功后
                    if (backdata.data.code == 200) {
                      this.change(1);
                      this.$Message.success(backdata.data.message);
                    } else {
                      this.loading = false;
                      this.$Message.error(backdata.data.message);
                    }
                  });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
      },

    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/billRedFlushTemporary.vue